// extracted by mini-css-extract-plugin
module.exports = {"buttons-group":"NewsLinkGroup_buttons-group__1VLnq","nav-item":"NewsLinkGroup_nav-item__1UXql","active-link":"NewsLinkGroup_active-link__w15Fr"};